import type { FabricEditor } from 'modules/fabric-editor';
import type { LayoutScopeKey } from 'modules/manager/domain/match-layout';

/**
 * Remove any canvas object whose `data[scopeKey]` points at a slot that wasn't
 * provided in the render context — `matchNumber` for match templates (a match
 * slot beyond the rendered matches), `teamNumber` for standings templates (a
 * table row beyond the group's teams). Matches the existing resolver-side drop
 * for placeholders with out-of-range slots (`resolver.ts:pickMatchSlot` /
 * `resolveStandingsPlaceholder`), extended to plain rect/text objects so
 * authors can per-slot-scope decorative elements (row backgrounds, dividers).
 *
 * The scope value is 1-based. Values 0/negative/undefined are treated as
 * "unset" (no removal).
 */
export async function filterScopedObjects(
  editor: FabricEditor,
  scopeKey: LayoutScopeKey,
  availableCount: number,
): Promise<void> {
  let removed = false;
  for (const obj of [...editor.canvas.getObjects()]) {
    const n = (obj.data as Record<string, number | undefined> | undefined)?.[scopeKey];
    if (typeof n === 'number' && n >= 1 && n > availableCount) {
      editor.canvas.remove(obj);
      removed = true;
    }
  }
  if (removed) editor.canvas.requestRenderAll();
}
